import React from 'react';
import { shape, string } from 'prop-types';
import Page from '../../components/Page';
import Footer from '../../components/case/Footer';
import QuoteSection from '../../components/case/QuoteSection';
import HeroSection from '../../components/case/HeroSection';

const SingleCasePage = ({
  nextCase,
  data,
  quoteData,
  alignHeroImage,
  centerHeroTitle,
  heroTitleSmaller,
  coverHero,
  children,
}) => (
  <Page offset>
    <HeroSection
      title={data.title}
      heroImg={data.hero}
      sideHeadingFirst={data.sideHeadingFirst}
      sideHeadingSecond={data.sideHeadingSecond}
      color={data.color}
      alignImage={alignHeroImage}
      centerHeroTitle={centerHeroTitle}
      smallerTitle={heroTitleSmaller}
      coverHero={coverHero}
    />
    {children}
    {
      data.quoteData && (
        <QuoteSection
          fullName={data.quoteData.name}
          profession={data.quoteData.profession}
        >
          {data.quoteData.quote}
        </QuoteSection>
      )
    }
    { nextCase && <Footer {...nextCase} /> }
  </Page>
);

SingleCasePage.propTypes = {
  nextCase: shape({
    title: string,
    path: string,
  }),
};

SingleCasePage.defaultProps = {
  nextCase: null,
};

export default SingleCasePage;
